export const AutoCorrespondencePermissions = {
  ViewAutoCorrespondenceConfiguration :  {
    permissionsId: "7509dbad-a707-4c56-c4d1-08dc683b0c43",
    permissionsName: "View Auto Correspondence Configuration",
    description: null,
    componentsId: null,
    components: null 
  }
};
